<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 200 200"
    style="enable-background: new 0 0 200 200"
    xml:space="preserve"
  >
    <rect style="fill: #efda4f" width="200" height="200" />
    <g>
      <path
        style="fill: #323330"
        d="M132,82.5c-2.6,1.7-5.2,3.4-6.9,4.3c-2.1-1.2-4.3-3-6.4-3.4c-2.6-0.9-4.7,0.4-5.5,2.6
		c-0.9,2.1,0,4.3,2.1,6c1.7,0.9,3.4,1.7,5.2,2.6c2.1,0.9,4.3,1.7,6.4,3c6.4,3.4,9,9,7.8,15.4c-1.2,6-5.2,9.9-12.4,11.1
		c-9,1.7-17.6-1.7-21.4-8.6c0-0.4-0.4-0.9-0.9-1.2c2.1-1.2,4.7-2.6,6.9-3.8c1.2-0.9,2.1,0,2.6,0.9c3,3.4,6.4,4.7,11.1,3.8
		c2.1-0.4,3.8-1.7,4.3-3.8c0.4-2.6-0.9-4.3-2.6-5.2c-1.7-0.9-3.8-1.7-5.5-2.6c-2.1-0.9-3.8-1.7-6-3c-6-3.8-8.6-9.9-6.9-16.3
		c1.7-5.5,6.9-9.4,13.7-9.4C123.8,74.3,128.6,76.5,132,82.5z"
      />
      <path
        style="fill: #333430"
        d="M94.3,76.1c0,0,0.4,23.5,0,35.6c-0.4,9.4-8.1,14.5-18,12.8c-5.5-0.9-9.4-3.8-12-9
		c1.2-0.9,2.6-1.7,3.8-2.6c1.2-0.9,2.6-1.7,4.3-2.6c0.9,1.2,1.7,2.6,2.6,3.4c1.7,1.7,4.7,2.6,6.9,1.7c2.1-0.9,3-3,3-5.2
		c0-10.7,0-21.4,0-32.2c0-0.9,0-3,0-3h9.4"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconJs",
};
</script>
